<p-popover #pwpopover>
  <div class="flex flex-col gap-4">
    <input
      pInputText
      type="text"
      [ngModelOptions]="{updateOn: 'blur'}"
      [(ngModel)]="this.rss.botConfig.botPassword"
      (ngModelChange)="this.rss.saveBotConfigField('botPassword')"
      />
  </div>
</p-popover>
<ng-template
  #headline
  let-item
  >
  <h3>
    @if (item ==='') {
      <i class="ri-chat-ai-line"></i>
      <span i18n="@@chat">Chat</span>
    }
    @if (item ==='/audio') {
      <i class="ri-voice-ai-line"></i>
      <span i18n="@@audio">Audio</span>
    }
    @if (item === '/avatar') {
      <i class="ri-video-ai-line"></i>
      <span i18n="@@avatar">Avatar</span>
    }
  </h3>
</ng-template>
<ng-template #exportTypeSelect>
  <div class="export-select-stack">
    <p-float-label variant="on">
      <p-select
        fluid
        [options]="this.getExportTypes()"
        [(ngModel)]="this.selectedExportType"
        optionLabel="name"
        class="w-full md:w-56"
        />
      <label
        for="username"
        i18n="@@view-label"
      >Ansicht</label>
    </p-float-label>
    <p-float-label variant="on">
      <p-select
        fluid
        [options]="this.exportLanguages"
        [(ngModel)]="this.selectedLanguage"
        optionLabel="name"
        class="w-full md:w-56"
        />
      <label
        for="username"
        i18n="@@system-language-label"
      >Systemsprache</label>
    </p-float-label>
  </div>
</ng-template>
<div class="row align-items-center embed-actions-row">
  <div class="col">
    <p-button
      size="small"
      severity="primary"
      [outlined]="true"
      icon="ri-arrow-right-line"
      iconPos="right"
      [routerLink]="['/bot-admin', this.rss.botConfig._id, 'access-control']"
      (onClick)="this.closeDrawer.emit()"
      i18n-label="@@manage-access"
      label="Freigaben verwalten"
    ></p-button>
  </div>
  <div class="col-auto embed-actions-buttons-col">
    <div class="embed-actions-buttons">
      <p-button
        size="small"
        severity="primary"
        (onClick)="this.botService.exportBotConfigZIP(this.rss.botConfig)"
        >
        <ng-template pTemplate="content">
          <i class="ri-download-2-fill me-2"></i>
          <span
            i18n="@@chat-bot-botconfig-offline-export"
            pTooltip="Dokumente sind nicht enthalten"
          >Download Backup (.zip)</span>
        </ng-template>
      </p-button>

      <p-button
        size="small"
        severity="primary"
        (onClick)="this.exportBot()"
        >
        <ng-template pTemplate="content">
          <i class="ri-share-forward-box-line me-1"></i>
          <span i18n="@@generate-share-link">
            Weitergabelink kopieren
          </span>
        </ng-template>
      </p-button>
    </div>
  </div>
</div>
<div class="row share-toggle-row">
  <div class="col-auto share-toggle-stack">
    <div
      class="share-activation-card"
      (click)="this.rss.botConfig.isPublic = !this.rss.botConfig.isPublic; this.rss.saveBotConfigField('isPublic')"
      >
      <div class="password-protection-card-main">
        <div class="password-protection-icon">
          <i [ngClass]="{
            'ri-share-forward-fill text-primary': this.rss.botConfig.isPublic,
            'ri-share-forward-line text-muted': !this.rss.botConfig.isPublic
          }"></i>
        </div>
        <div class="password-protection-copy">
          <span
            class="password-protection-label share-toggle-inline-label"
            i18n="@@share-active-label"
          >Freigabe aktiv</span>
          <span class="password-protection-state text-muted">
            @if (this.rss.botConfig.isPublic) {
              <span i18n="@@status-active">Aktiv</span>
            }
            @else {
            <span i18n="@@status-inactive">Deaktiviert</span>
          }
        </span>
      </div>
    </div>
  </div>
  <div
    class="password-protection-card"
    [ngClass]="{'password-protection-card-disabled': !this.rss.botConfig.isPublic }"
    (click)="this.rss.botConfig.isPwProtected = !this.rss.botConfig.isPwProtected; this.rss.saveBotConfigField('isPwProtected')"
    >
    <div class="password-protection-card-main">
      <div class="password-protection-icon">
          <i [ngClass]="{
            'ri-lock-password-fill text-primary': this.rss.botConfig.isPwProtected,
            'ri-lock-unlock-line text-muted': !this.rss.botConfig.isPwProtected
            }"></i>
      </div>
      <div class="password-protection-copy">
        <span
          class="password-protection-label"
          i18n="@@password-protection-label"
        >Passwortschutz</span>
        <span class="password-protection-state text-muted">
          @if (this.rss.botConfig.isPwProtected) {
            <span i18n="@@status-active">Aktiv</span>
          }
          @else {
          <span i18n="@@status-inactive">Deaktiviert</span>
        }
      </span>
    </div>
  </div>
  @if(this.rss.botConfig.isPwProtected ){
    <div class="password-protection-actions">
      <button
        type="button"
        class="password-protection-edit"
        (click)="this.copyPasswordToClipboard(); $event.stopPropagation()"
        i18n-aria-label="@@copy-password-aria"
        aria-label="Passwort kopieren"
        >
        <i class="ri-file-copy-line"></i>
      </button>
      <button
        type="button"
        class="password-protection-edit"
        (click)="pwpopover.show($event); $event.stopPropagation()"
        i18n-aria-label="@@edit-password-protection-aria"
        aria-label="Passwortschutz bearbeiten"
        >
        <i class="ri-edit-2-fill"></i>
      </button>
    </div>
  }
</div>
@if (this.loginService.hasSUPERAdmin()) {
  <div
    class="share-activation-card"
    (click)="this.rss.botConfig.isTemplate = !this.rss.botConfig.isTemplate; this.onTemplateToggle(this.rss.botConfig.isTemplate)"
    >
    <div class="password-protection-card-main">
      <div class="password-protection-icon">
          <i [ngClass]="{
            'ri-draft-fill text-primary': this.rss.botConfig.isTemplate,
            'ri-draft-line text-muted': !this.rss.botConfig.isTemplate
          }"></i>
      </div>
      <div class="password-protection-copy">
        <span
          class="password-protection-label share-toggle-inline-label"
          i18n="@@is-template"
        >Template</span>
        <span class="password-protection-state text-muted">
          @if (this.rss.botConfig.isTemplate) {
            <span i18n="@@status-active">Aktiv</span>
          }
          @else {
          <span i18n="@@status-inactive">Deaktiviert</span>
        }
      </span>
    </div>
  </div>
</div>
}
</div>

<div class="col"></div>

</div>


<p-tabs
  style="margin-top:2px"
  value="2"
  [ngClass]="{'disabled': !this.rss.botConfig.isPublic}"
  >
  <p-tablist>
    <p-tab
      value="2"
      i18n="@@tab-link"
    >Link</p-tab>

    <p-tab
      value="1"
      i18n="@@tab-exports"
    >Exporte</p-tab>

    <p-tab
      value="0"
      i18n="@@tab-embed"
    >Einbetten</p-tab>

  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">

      <ng-container *ngTemplateOutlet="exportTypeSelect;"></ng-container>
      <p-float-label
        variant="on"
        class="embed-type-field"
        >
        <p-select
          fluid
          [options]="this.embedTypes"
          [(ngModel)]="this.selectedEmbedType"
          optionLabel="name"
          class="w-full md:w-56"
          />
        <label
          for="username"
          i18n="@@embed-type"
        >Einbettungsart</label>
      </p-float-label>

      <div
        class="link-preview-card"
        role="button"
        tabindex="0"
        (click)="copyToClipboardTxt(this.generateEmbedCode())"
        (keydown.enter)="copyToClipboardTxt(this.generateEmbedCode())"
        (keydown.space)="copyToClipboardTxt(this.generateEmbedCode()); $event.preventDefault()"
        >
        <div class="link-preview-header">
          <div class="link-preview-title-wrap">
            <i class="ri-code-s-slash-line text-primary"></i>
            <span i18n="@@embed-code-label">Einbettungscode</span>
          </div>
          <span
            class="link-preview-hint"
            i18n="@@click-copy-hint"
          >Klicken zum Kopieren</span>
        </div>
        <pre class="link-code-field"><code
          [highlight]="this.generateEmbedCode()"
          language="html"
        ></code></pre>
      </div>

    </p-tabpanel>
    <p-tabpanel value="1">
      <ng-container *ngTemplateOutlet="exportTypeSelect;"></ng-container>

      <div class="row export-instant-access-row export-instant-access-card w-full md:w-56">
        <div class="col-auto export-instant-access-toggle">
          <p-toggleswitch
            class="mb-0"
            [(ngModel)]="this.rss.botConfig.enableInstantAccess"
            (ngModelChange)="this.rss.saveBotConfigField('enableInstantAccess')"
            >
            <ng-template
              #handle
              let-checked="checked"
              >
              <i [ngClass]="['!text-xs', 'ri', checked ? 'ri-check-line' : 'ri-close-line']"></i>
            </ng-template>

          </p-toggleswitch>
        </div>
        <div class="col export-instant-access-copy">
          <span
            class="export-section-label"
            i18n="@@instant-access-option-label"
          >Nutzer Wiedererkennungsoption</span>
          <span
            class="smaller text-muted export-instant-access-desc"
            i18n="@@instant-access-option-desc"
            >Der Bot erkennt den LMS-User per Student-ID und führt ihn in der
            <b>Freigabe-Verwaltung.</b></span>
          </div>
        </div>

        <h5
          class="export-section-title"
          i18n="@@lms-exports-heading"
        >LMS Exporte:</h5>
        <div class="row align-items-start export-item-row">
          <div class="col-md-3 col-12 export-item-label">Scorm 1.2</div>
          <div class="col-md-9 col-12 export-item-actions">
            <p-button
              size="small"
              severity="primary"
              styleClass="text-start lms-download-button"
              (onClick)="this.zipService.buildZip(this.selectedExportType, false, 'scorm', this.downloadZipName(false, 'scorm'))"
              >
              <ng-template pTemplate="content">
                <i class="ri-download-2-fill me-2"></i>Download Scorm 1.2 Package (.zip)
              </ng-template>
            </p-button>
            @if(this.rss.botConfig.enableInstantAccess ){
              <p-button
                size="small"
                severity="primary"
                styleClass="text-start lms-download-button"
                (onClick)="this.zipService.buildZip(this.selectedExportType, true,'scorm', this.downloadZipName(true, 'scorm'))"
                >
                <ng-template pTemplate="content">
                  <i class="ri-download-2-fill me-2"></i>Download Tracking Scorm 1.2 Package (.zip)
                </ng-template>
              </p-button>
            }
          </div>
        </div>
        <div class="row align-items-start export-item-row">
          <div class="col-md-3 col-12 export-item-label">Scorm 2004</div>
          <div class="col-md-9 col-12 export-item-actions">
            <p-button
              size="small"
              severity="primary"
              styleClass="text-start lms-download-button"
              (onClick)="this.zipService.buildZip(this.selectedExportType, false, 'scorm2004', this.downloadZipName(false, 'scorm2004'))"
              >
              <ng-template pTemplate="content">
                <i class="ri-download-2-fill me-2"></i>Download Scorm 2004 Package (.zip)
              </ng-template>
            </p-button>
            @if(this.rss.botConfig.enableInstantAccess ){
              <p-button
                size="small"
                severity="primary"
                styleClass="text-start lms-download-button"
                (onClick)="this.zipService.buildZip(this.selectedExportType, true, 'scorm2004', this.downloadZipName(true, 'scorm2004'))"
                >
                <ng-template pTemplate="content">
                  <i class="ri-download-2-fill me-2"></i>Download Tracking Scorm 2004 Package (.zip)
                </ng-template>
              </p-button>
            }
          </div>
        </div>
        <!--       <div class="row align-items-center mt-4">
        <div class="col-3">XAPI</div>
        <div class="col">
          <div class="btn btn-sm btn-outline-primary  text-start mb-2">
            <i class="ri-download-2-fill"></i> {{this.downloadZipName(false, "xapi")}}
          </div>
          @if(this.rss.botConfig.enableInstantAccess ){
            <div class="btn btn-sm btn-outline-primary text-start ">
              <i class="ri-download-2-fill"></i> {{this.downloadZipName(true, "xapi")}}
            </div>
          }
        </div>
      </div> -->
      <h5
        class="export-section-title"
        i18n="@@integration-in-heading"
      >Integration in:</h5>
      <div class="row align-items-start export-item-row">
        <div
          class="col-md-3 col-12 export-item-label"
          i18n="@@adobe-connect-pod-label"
        >Pod für Adobe Connect</div>
        <div class="col-md-9 col-12 export-item-actions">
          <p-button
            size="small"
            severity="primary"
            styleClass="text-start lms-download-button"
            (onClick)="this.zipService.buildZip(this.selectedExportType, false, 'pod', this.downloadZipName(false, 'pod'))"
            >
            <ng-template pTemplate="content">
              <i class="ri-download-2-fill me-2"></i>Download Adobe Connect Pod (.zip)
            </ng-template>
          </p-button>
          <!-- @if(this.rss.botConfig.enableInstantAccess ){
          <div class="btn btn-sm btn-outline-primary  text-start">
            <i class="ri-download-2-fill"></i> {{this.downloadZipName(true, "pod")}}
          </div>
          } -->
        </div>
      </div>
    </p-tabpanel>
    <p-tabpanel value="2">
      <ng-container *ngTemplateOutlet="exportTypeSelect;"></ng-container>

      <div
        class="link-preview-card"
        role="button"
        tabindex="0"
        (click)="copyToClipboardTxt(this.getDirectLink())"
        (keydown.enter)="copyToClipboardTxt(this.getDirectLink())"
        (keydown.space)="copyToClipboardTxt(this.getDirectLink()); $event.preventDefault()"
        >
        <div class="link-preview-header">
          <div class="link-preview-title-wrap">
            <i class="ri-link text-primary"></i>
            <span i18n="@@direct-link-label">Direkter Link</span>
          </div>
          <span
            class="link-preview-hint"
            i18n="@@click-copy-hint"
          >Klicken zum Kopieren</span>
        </div>
        <pre class="link-code-field"><code
          [highlight]="this.getDirectLink()"
          language="html"
        ></code></pre>
      </div>

      <div class="row">

        <!--  <div class="col">
        <div
          class="btn btn-outline-primary"
          (click)="copyToClipboardTxt(this.getDirectLink())"
          i18n="@@copy-link-button"
        >QR-Bild Link kopieren</div>
        <br />
        <div
          class="btn btn-outline-primary mt-2"
          (click)="copyToClipboardTxt(this.getDirectLink())"
          i18n="@@copy-link-button"
        >QR-Bild Herunterladen</div>
      </div> -->
      <div class="col text-center"><img
        [src]="this.getQRUrl()"
        class="shadow border-1"
        style="border: 1px solid #CBD5E1"
        height="200px"
        alt="QR-Code"
      ></div>
    </div>
  </p-tabpanel>
  <p-tabpanel value="3">

    <span i18n="@@generate-export-offline">Bot-Backup als Export-Datei (.zip) erzeugen</span>
    <br>

      <br>
        <br>
          <span i18n="@@generate-import-link">Bot-Import-Link erzeugen</span>
          <br>



          </p-tabpanel>

        </p-tabpanels>
      </p-tabs>